import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "children", "onClearFilter", "flush"];
import styled from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { RemoveIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Main = styled.div.attrs(({
  $active
}) => ({
  'data-test-id': 'filter-wrapper',
  'data-test-info': $active ? 'filterbar-highlighted' : 'filterbar-plain'
}))(({
  $flush,
  $active,
  theme
}) => `
  display: inline-flex;
  padding-inline: ${$flush ? '0' : theme.space['300']};
  ${$active && `
    background-color: ${theme.color['fill-field-hover']};
    border-radius: ${theme.borderRadius['100']};
    `};
`);
export default function ListingLibFilterWrapper(_ref) {
  let {
      active,
      children,
      onClearFilter,
      flush
    } = _ref,
    divProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Main, Object.assign({
    $active: active,
    $flush: flush
  }, divProps, {
    children: [children, active && onClearFilter && /*#__PURE__*/_jsx(Flex, {
      children: /*#__PURE__*/_jsx(IconButton, {
        use: "transparent",
        size: "extra-small",
        onClick: onClearFilter,
        children: /*#__PURE__*/_jsx(RemoveIcon, {
          color: "icon-primary-disabled"
        })
      })
    })]
  }));
}